/**
 * Boot: picks which front end runs on this device.
 *
 * - v2 (src/v2): the calendar app specified by
 *   docs/prototypes/v2_calendar_prototype.html. Opt-in while it is being
 *   built (see ui-choice.ts).
 * - v1 (src/legacy + public/app.js): the Racked-era logger, still the default.
 *
 * Both share the session (auth.ts), the offline store and sync (store.ts) and
 * the service worker (updates.ts), so data moves freely between them.
 */
import { chooseUi } from "./ui-choice.js";
import { watchForUpdates } from "./updates.js";

function loadClassicScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`failed to load ${src}`));
    document.body.append(s);
  });
}

async function startLegacy(): Promise<void> {
  // Styles first, so the markup never shows unstyled.
  await import("./legacy/styles.css");
  const tpl = document.getElementById("legacy-markup") as HTMLTemplateElement;
  document.body.prepend(tpl.content.cloneNode(true));
  await loadClassicScript("/app.js");
  await import("./legacy/main.js");
}

async function startV2(): Promise<void> {
  const { start } = await import("./v2/main.js");
  start();
}

watchForUpdates();
void (chooseUi() === "v2" ? startV2() : startLegacy());
